export default __webpack_public_path__ + "static/media/skull.04f92aea.png";